// emailToOffer decides what the appointment sheet shows for the email typed on
// the booking page: nothing, "Save to client" (she has none on file), or
// "Replace client email" (she has a different one). Only she changes a client
// that already existed, so the form's email is offered, never applied. A
// confirmed email is locked: nothing is offered to replace it.
export function emailToOffer(
  given: string | null | undefined,
  stored: string | null | undefined,
  storedConfirmed = false,
): { email: string; replace: boolean } | null {
  const email = (given ?? '').trim()
  if (!email || storedConfirmed) return null
  const current = (stored ?? '').trim()
  if (!current) return { email, replace: false }
  if (current.toLowerCase() === email.toLowerCase()) return null
  return { email, replace: true }
}
